import { m } from 'framer-motion';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';
import { Container } from 'react-bootstrap';
import Tab01 from '../../../Litho/Components/Tab/Tab01';
import activitiesData from './activitiesData';
import { Element } from 'react-scroll';

const ServicesSection = () => {
	return (
		<Element name='activities'>
			<m.section className='overflow-x-hidden pb-20' {...fadeIn}>
				<Container>
					<div className='flex flex-col gap-0 items-center text-center'>
						<span className='text-tprimary'>Our Services</span>
						<h3 className='text-ttertiary font-calistoga'>
							Everything is ready to
							<br />
							transport
						</h3>
						<p className='notMobile:w-[50%] mb-20'>
							We make logistics shiping much easier and straightforward.
							Combining good services and technology make everything efficient.
						</p>
					</div>
					<Tab01 data={activitiesData} />
				</Container>
			</m.section>
		</Element>
	);
};

export default ServicesSection;
